
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PuttSituation } from "@/types/golf";
import { TestResult } from "@/types/results";
import { useTranslation } from "react-i18next";

type PuttingResultsProps = {
  puttingSituations: PuttSituation[];
  results: TestResult[];
  totalPoints: number;
  totalIndex: number;
};

export const PuttingResults = ({ puttingSituations, results, totalPoints, totalIndex }: PuttingResultsProps) => {
  const { t } = useTranslation('results');
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl text-golf-700">{t('putting.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-12">{t('table.number')}</TableHead>
              <TableHead>{t('table.situation')}</TableHead>
              <TableHead className="text-right">{t('table.points')}</TableHead>
              <TableHead className="text-right">{t('table.index')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {puttingSituations.map((situation) => {
              const result = results.find(r => r.situation_id === situation.id);
              return (
                <TableRow key={situation.id}>
                  <TableCell className="font-medium">{situation.id}</TableCell>
                  <TableCell>{t(`situations.situation_${situation.id}`)}</TableCell>
                  <TableCell className="text-right">{result?.points || "-"}</TableCell>
                  <TableCell className="text-right">{result?.index || "-"}</TableCell>
                </TableRow>
              );
            })}
            <TableRow className="font-bold bg-golf-50">
              <TableCell colSpan={2}>{t('putting.total')}</TableCell>
              <TableCell className="text-right">{totalPoints}</TableCell>
              <TableCell className="text-right">{totalIndex}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
